module.exports = __webpack_public_path__ + "img/bullet.ef3b5d2b.svg";